import { render, staticRenderFns } from "./Customize.vue?vue&type=template&id=6a4fe0fb&scoped=true"
import script from "./Customize.vue?vue&type=script&lang=js"
export * from "./Customize.vue?vue&type=script&lang=js"
import style0 from "./Customize.vue?vue&type=style&index=0&id=6a4fe0fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4fe0fb",
  null
  
)

export default component.exports